import { ICampaign } from '../interfaces';
import { IWeekData } from './weeks-viewer';

export const panelMergeSameName = (weeks: IWeekData[]) => {
    const out_weeks: IWeekData[] = [];
    let maxLen = 0;

    for (const w of weeks) {
        const cw: IWeekData = { dateStart: w.dateStart, campaigns: [] };
        const campNames: { [name: string]: ICampaign } = {};

        for (const c of w.campaigns) {
            if (!c) continue;

            const name = c.groupName || c.name;
            if (name in campNames) {
                campNames[name].devices = [...new Set([...campNames[name].devices, ...c.devices])];
            } else {
                campNames[name] = {
                    ...c,
                    devices: [...c.devices]
                };
            }
        }

        cw.campaigns = Object.values(campNames);
        maxLen = Math.max(cw.campaigns.length, maxLen);

        out_weeks.push(cw);
    }

    for (const w of out_weeks) {
        while (w.campaigns.length < maxLen) {
            w.campaigns.push(null);
        }
    }

    return out_weeks;
};
